<template>
  <div :class="parent ? 'text-sm my-2 font-normal text-gray-400 space-y-2 -ml-6' : ''">
    <router-link
      v-slot="{ route: lroute }"

      :to="to"
      custom
    >
      <li
        :class="[disabled ? '!text-gray-300 cursor-not-allowed' : 'text-gray-600', active ? 'text-gray-800 font-medium' : ' hover:underline', 'focus:border-blue-400 focus:ring-1 focus:ring-blue-200 focus:outline-none cursor-pointer group flex items-center px-4 rounded-md']"
        @click="go(lroute)"
      >
        <span
          v-tooltip.bottom="name"
          class="truncate hover:underline"
        >
          {{ name }}
        </span>
        <span
          v-if="!disabled && badge"
          class="ml-auto text-right font-normal text-sm"
        >
          {{ badge }}
        </span>
      </li>
    </router-link>
    <slot />
    <div :class="[withSep ? 'space-y-1 border-b border-gray-100 pb-2 ml-3' : '']" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useProp } from '@/composables/useProp.js'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const routerRoute = useRoute()

const props = defineProps({
  name: useProp([String, Number]),
  icon: useProp(String),
  parent: useProp(Boolean),
  badge: useProp(String, ''),
  badgeColor: useProp(String, 'red'),
  disabled: useProp(Boolean, false),
  withSep: useProp(Boolean, false),
  active: useProp(Boolean, false),
  useActiveParam: useProp(Boolean, false),
  animate: useProp(Boolean, false),
  open: useProp(Boolean, false),
  strokeWidth: useProp(Number, 1.5),
  route: useProp(Object)
})

const active = computed(() => {
  if (props.useActiveParam) {
    return props.active
  }
  return routerRoute.path === to.value
})

const go = (nRoute) => {
  if (nRoute.fullPath !== routerRoute.fullPath && !props.disabled && !active.value) {
    router.push(nRoute)
  }
}

const to = computed(() => {
  const newRoute = router.resolve(props.route)
  return newRoute.href
})

</script>
